import { useTranslation } from 'react-i18next';

import useDeleteUser from 'Domain/user/useDeleteUser';
import { useModal } from 'Store/modal';

const useOpenDeleteModal = () => {
  const { t } = useTranslation('user');
  const { onOpenModal } = useModal();

  const { mutate: onDeleteUser } = useDeleteUser();

  const onOpenDeleteModal = (id) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('deleteUserTitle'),
      contentDescription: t('deleteUserDescription'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('deleteUserSubmitButton'),
      secondaryButtonText: t('deleteUserCancelButton'),
      onClickPrimaryButton: () => {
        onDeleteUser(id);
      },
    });
  };

  return { onOpenDeleteModal };
};

export default useOpenDeleteModal;